import type { SearchColumnDef } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export const getDocumentsColumns = (): SearchColumnDef[] => [
  {
    field: 'tk_no',
    headerName: 'Tk doanh thu',
    width: 120,
    renderCell: params => params.row.tk_dt_data?.code || ''
  },
  {
    field: 'ten_tk_no',
    headerName: 'Tên tài khoản',
    width: 200,
    renderCell: params => params.row.tk_dt_data?.name || ''
  },
  {
    field: 'tien_nt2',
    headerName: 'Tiền VND',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt2)
  },
  {
    field: 'ma_thue',
    headerName: 'Mã thuế',
    width: 120,
    renderCell: params => params.row.ma_thue_data?.ma_thue
  },
  {
    field: 'tk_thue_no',
    headerName: 'Tk thuế',
    width: 120,
    renderCell: params => params.row.tk_thue_co_data?.code || ''
  },
  {
    field: 'thue_suat',
    headerName: 'Thuế suất (%)',
    width: 120,
    type: 'number',
    renderCell: params => params.row.ma_thue_data?.thue_suat
  },
  {
    field: 'thue_nt',
    headerName: 'Thuế VND',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(params.row.thue_nt)
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 250
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => params.row.ma_vv_data?.ma_vu_viec
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => params.row.ma_hd_data?.ma_hd
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 150,
    renderCell: params => params.row.ma_dtt_data?.ma_dtt
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    renderCell: params => params.row.ma_ku_data?.ma_ku
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 100,
    renderCell: params => params.row.ma_phi_data?.ma_phi
  },
  {
    field: 'ma_vt',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_sp_data?.ma_vt
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 150,
    renderCell: params => params.row.ma_lsx_data?.ma_lsx
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 150,
    renderCell: params => params.row.ma_cp0_data?.ma_cpkhl
  }
];
